import { Box, Button, Card, InputAdornment, CardContent, CardMedia, Chip, FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, Stack, IconButton, Tooltip, Typography, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled, width } from '@mui/system';
import StarIcon from '../../../../img/StarIcon.png'
import SearchBox from '../../../../components/reusableComponents/SearchBox';
import ApiService from '../../../../_services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import NoResults from '../../../../components/reusableComponents/NoResults';
import SnackbarContainer from '../../../Snackbar';
import { useHistory } from 'react-router-dom';
import Pagination from '../../../../_helpers/reusablefunctions/Pagination';
import SkeletonCard from '../../../../_helpers/reusablefunctions/SkeletonCard';
import playlist from '../../../../img/default-image.png'
import { fetchMasterData } from '../../../../redux/masterData/masterDataActions';
import SwitcherBtn from '../../../../components/reusableComponents/SwitcherBtn';
import TableComponent from '../../../../components/Tablecomponent';
import ClearIcon from '@mui/icons-material/Clear';

const StyledChip = styled(Chip)(({ theme }) => ({
    borderRadius: '10px',
    color: '#545454',
    background: '#fff',
    border: '0px',
    padding: '6px 20px 6px 20px',
    fontSize: '14px',
    '&:hover': {
        backgroundColor: '#ED1C24',
        color: '#fff',
    },
    '&.MuiChip-clickable:focus, &.MuiChip-clickable:hover': {
        backgroundColor: '#ED1C24',
        color: '#fff',
    },
    '&.MuiChip-clickable': {
        '&.Mui-active': {
            backgroundColor: '#ED1C24',
            color: '#fff',
        },
    },
}));

export default function Discover() {
    const userData = useSelector((state) => state.userData.userData);
    // Redux state
    const masterData = useSelector((state) => state.masterData.masterData);
    const optionsMap = {
        genre: masterData.genre || [],
        mood: masterData.mood || [],
        language: masterData.language || [],
    };
    const history = useHistory()
    const dispatch = useDispatch();
    const [selectedFilters, setSelectedFilters] = useState({
        genre: '',
        mood: '',
        language: '',
    });
    const [songList, setSongList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [activeChip, setActiveChip] = useState('0-0');
    const [openRatingDialog, setOpenRatingDialog] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState()
    const [playlistId, setPlaylistId] = useState('')
    const [searchInput, setSearchInput] = useState('')
    const [activeLabel, setActiveLabel] = useState('discover-song-list');
    // View mode state
    const [viewMode, setViewMode] = useState(true); // 'card' or 'table'

    const filterSongs = [
        { label: 'discover-song-list', value: ["All Songs"] },
        { label: 'getRelatedSongs', value: ["Related Songs"] },
        { label: 'getMySong', value: ['My Songs'] },
    ];

    // Define table columns
    const columnsSong = [
        {
            id: 'songPoster',
            label: 'Song Title',
            template: (row) => (
                <Box
                    onClick={() => openDetails(row)}
                    display="flex"
                    alignItems="center"
                    gap={2}>
                    <img
                        src={getImageUrl(row, 'table')}
                        alt="song thumbnail"
                        style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                    />
                    <Tooltip title={row?.songTitle} placement="top" arrow>
                        <Typography
                            variant='body2'
                            className='text-truncate'
                            style={{ cursor: 'pointer' }}
                            onClick={() => openDetails(row)}
                        >
                            {row?.songTitle || '--'}
                        </Typography>
                    </Tooltip>
                </Box>
            ),
        },
        {
            id: 'artists',
            label: 'Artists',
            template: (row) => (
                <Box display="flex" alignItems="center" gap={2}>
                    <Tooltip title={row?.artists} placement="top" arrow>
                        <Typography
                            variant='body2'
                            className='text-truncate'
                            style={{ cursor: 'pointer' }}
                        >
                            {row?.artists || '--'}
                        </Typography>
                    </Tooltip>
                </Box>
            ),
        }, {
            id: 'genre',
            label: 'Genre',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.genre?.genre || '--'}
                </Typography>
            ),
        },
        {
            id: 'mood',
            label: 'Mood',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.mood?.mood || '--'}
                </Typography>
            ),
        },
        {
            id: 'language',
            label: 'Language',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.language?.language || '--'}
                </Typography>
            ),
        },
        {
            id: 'rating',
            label: 'Rating',
            template: (row) => {
                return (
                    <Box className='d-flex align-items-center gap-2'>
                        <img src={StarIcon} alt='StarIcon' style={{ width: 16, height: 16 }} />
                        <Typography variant="body2">
                            {row?.song_rating ? `${row.song_rating.average_rating}/5 (${row.song_rating.rating_count} Rating)` : '0/5 (0 Rating)'}
                        </Typography>
                    </Box>
                );
            },
        },

    ];

    function songlistApi(url) {
        const premium_user = userData?.enable_distribution ? 'True' : 'False';
        const userId = url == 'getMySong' || url == "getRelatedSongs" ? userData?.id : null
        let params = {
            premium_users: premium_user,
            verified_users: 'Verified',
            limit: rowsPerPage,
            offset: page,
            userId: userId
        };

        // If URL is 'discover-song-list', override params
        if (url === 'discover-song-list') {
            params = {
                limit: rowsPerPage,
                offset: page,
                userId: userId
            };
        }
        setLoader(true)
        setSongList([])
        ApiService.get('allsongslist', params, url + '/').then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setSongList(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(function (error) {
            console.log(error);
            console.log(error.response);
        });
    }

    function tredingMusicApi(value) {
        let searchValue = (value == 'artist') ? '' : value;
        let trending_artists = value == 'artist' ? 'true' : ''
        setLoader(true)
        setSongList([])
        ApiService.get('allsongslist', { search: searchValue, verified_users: 'Verified', trending_artists, limit: rowsPerPage, offset: page }, 'search_allsongs').then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setSongList(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(function (error) {
            console.log(error);
            console.log(error.response);
        });
    }

    function getSearchList() {
        const premium_user = userData?.enable_distribution ? 'True' : 'False'
        setLoader(true)
        ApiService.get('searchSong', { search: searchInput, limit: rowsPerPage, offset: page, premium_users: premium_user, verified_users: 'Verified' }).then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setSongList(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(error => {
            console.log(error);
            console.log(error.response);
        })
    }

    useEffect(() => {
        if (searchInput != null && searchInput.length > 0) {
            let delaySearch;
            delaySearch = setTimeout(() => {
                getSearchList()
            }, 1000);
            return () => clearTimeout(delaySearch)
        } else {
            if (userData) {
                songlistApi('discover-song-list')
            }
        }

    }, [userData, page, rowsPerPage, searchInput])

    // Fetch master data on mount
    useEffect(() => {
        dispatch(fetchMasterData());
    }, [dispatch]);

    const handleChipClick = (i, label, value) => {
        setActiveChip(i)
        setActiveLabel(label)
        if (label == "trending" || label == 'artist') {
            tredingMusicApi(label)
        } else {
            songlistApi(label)
        }
        // history.push(`?tab=${label}`);

    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value);
        const newPage = Math.floor((page * rowsPerPage) / newRowsPerPage);
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleSearchInput = (value) => {
        setSearchInput(value)
    }

    // Handle layout component change
    const handleLayoutComponent = (currentComp) => {
        setViewMode(currentComp)
    }

    // Fetch analytics data for the song
    async function fetchSongAnalytics(data) {
        let user = {
            uid: userData?.creator_auth,
            platform: 'web'
        };
        try {
            const response = await ApiService.post('songAnalytics', { user }, `${data?.id}/click?revoke=false`);
            if (response.status === 200 || response.status === 201) {
                // Handle the response data as needed
                console.log('Song Analytics:', response.data);
            }
        } catch (error) {
            console.error('Error fetching song analytics:', error);
        }
    }

    const openDetails = async (data) => {
        await fetchSongAnalytics(data);

        if (activeLabel == "artist") {
            history.push('/artist-profile', { data: data, page: 'artist' })
        } else {
            history.push(`/songdetail/${data.id}`, { musicData: data })
        }
    }

    const getImageUrl = (data, value) => {
        if (activeLabel === 'artist' && data?.avatar) {
            return `${process.env.REACT_APP_BASEURL_MEDIA}/media/${data.avatar}`;
        }
        if (activeLabel === 'artist' && data?.avatar_url) {
            return data?.avatar_url
        }
        if (data?.songPoster100x100 || data.songPoster300x300) {
            return value == 'card' ? data?.songPoster300x300 : data?.songPoster100x100
        }
        if (data?.songPoster_url) {
            return data?.songPoster_url;
        }
        if (data?.songPoster) {
            return `${process.env.REACT_APP_BASEURL_MEDIA}/media/${data.songPoster}`;
        }
        if (data?.cover_image) {
            return `${process.env.REACT_APP_SONGAPIURL_MEDIA}${data.cover_image}`
        }
        return playlist;
    };

    // Genre,Mood and Language filter
    const updateFilters = (type, value) => {
        setLoader(true);
        setSongList([]);

        const updatedFilters = {
            ...selectedFilters,
            [type]: value,
        };

        setSelectedFilters(updatedFilters);

        const params = {
            genre: updatedFilters.genre,
            mood: updatedFilters.mood,
            language: updatedFilters.language,
        };

        ApiService.get('discoverSongList', params)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    setSongList(response.data.results || []);
                }
            })
            .catch(error => {
                console.error('Error fetching filtered songs:', error);
            })
            .finally(() => {
                setLoader(false);
            });
    };

    const handleValueChange = (e, type) => {
        updateFilters(type, e.target.value);
    };

    const handleClearSingleFilter = (type) => {
        updateFilters(type, '');
    };


    // Render card view
    const renderCardView = () => (
        <Grid container spacing={2}>
            {loader ?
                Array.from(new Array(8)).map((item, index) => (
                    <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
                        <SkeletonCard />
                    </Grid>
                ))
                :
                loader === false && songList.length === 0 ? (
                    <NoResults message="No Result Found" />
                )
                    :
                    songList.map((data, index) => (
                        <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
                            <Card>
                                <CardMedia
                                    sx={{
                                        aspectRatio: '1 / 1',
                                        width: '100%',
                                        objectFit: 'cover',
                                        cursor: 'pointer'
                                    }}
                                    image={getImageUrl(data, 'card')}
                                    title="song-thumbnail"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => openDetails(data)}
                                />
                                <CardContent sx={{ paddingBottom: '0px' }}>
                                    <Tooltip title={activeLabel == 'artist' ? data?.name : data.songTitle}
                                        placement="top"
                                        arrow>
                                        <Typography className='text-truncate'>
                                            {activeLabel == 'artist' ? data?.name : data?.songTitle || '--'}
                                        </Typography>
                                    </Tooltip>
                                    {activeLabel == 'artist' ? null : (
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }} component="div" className='d-flex align-items-center gap-2'>
                                            <img src={StarIcon} alt='StarIcon' />
                                            {data?.song_rating ? `${data.song_rating.average_rating}/5 (${data.song_rating.rating_count} Rating)` : '0/5 (0 Rating)'}
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
            }
            <Pagination
                totalCount={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Grid>
    );

    // Render table view
    const renderTableView = () => {
        if (loader) {
            return (
                <Paper>
                    <Box p={3}>
                        {Array.from(new Array(5)).map((_, index) => (
                            <Skeleton key={index} variant="rectangular" height={60} sx={{ mb: 1 }} />
                        ))}
                    </Box>
                </Paper>
            );
        }

        if (songList.length === 0) {
            return <NoResults message="No Result Found" />;
        }

        return (
            <Paper>
                <TableComponent
                    totalCount={totalCount}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    page={page}
                    columns={columnsSong}
                    data={songList}
                />
            </Paper>
        );
    };

    return (
        <Box className='container-fluid py-4 px-4 creator-playlist-panel'>
            <Box>
                <h2>Discover-Music</h2>
            </Box>
            <Box className="d-flex align-items-center justify-content-between my-4 flex-wrap gap-2">
                <Stack direction="row" spacing={1}>
                    {filterSongs.map((d, i) =>
                        d.value.map((v, index) => (
                            <StyledChip
                                key={`${i}-${index}`}
                                label={v}
                                component="a"
                                variant="outlined"
                                clickable
                                onClick={() => handleChipClick(`${i}-${index}`, d.label, v)}
                                className={activeChip === `${i}-${index}` ? 'Mui-active' : ''}
                            />
                        ))
                    )}
                </Stack>
                <Box className="d-flex align-items-center gap-2">
                    <SwitcherBtn layoutComponent={viewMode} handleLayoutComponent={handleLayoutComponent} />
                    {activeLabel == 'discover-song-list' && <SearchBox handleSearchInput={handleSearchInput} />}
                </Box>
            </Box>

            {activeLabel == 'discover-song-list' && (
                <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row', width: '50%' }}>

                    {/* Dropdown (dependent) */}
                    {['genre', 'mood', 'language'].map((data) => (
                        <FormControl key={data} fullWidth size='small'>
                            <InputLabel>Select {data}</InputLabel>
                            <Select value={selectedFilters[data]}
                                label={`Select ${data}`}
                                endAdornment={
                                    selectedFilters[data] && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                size="small"
                                                onClick={() => handleClearSingleFilter(data)}
                                                edge="end"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }
                                onChange={(e) => handleValueChange(e, data)}>
                                {optionsMap[data]?.map((item) => (
                                    <MenuItem key={item.id} value={item[data]}>
                                        {item[data]}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>))}

                    {(selectedFilters.genre || selectedFilters.mood || selectedFilters.language) && (
                        <Button
                            variant='text'
                            onClick={() => {
                                setSelectedFilters({ genre: '', mood: '', language: '' });
                                songlistApi('discover-song-list'); // fallback to all songs
                            }}
                        >
                            Clear
                        </Button>
                    )}

                </Box>
            )}

            <Box className='my-4'>
                {!viewMode ? renderCardView() : renderTableView()}
            </Box>
            <SnackbarContainer />
        </Box>
    )
}